module.exports = __webpack_public_path__ + "img/ThumbCMC.6dc8f6b7.svg";